import { useState } from 'react';
import { updateBorrowerProfile } from '../../apis/borrower';
import { handleApiError } from '../../helpers';
import { BorrowerDto, EmploymentType, BorrowerProfileFormValues } from '../../interfaces';
import FormData from 'form-data';
import { toast } from 'react-toastify';

export const useUpdateBorrowerProfile = () => {
  const [submitting, setSubmitting] = useState(false);
  const formData = new FormData();

  const createMultiPartFormData = (payload: BorrowerDto) => {
    for (const [key, value] of Object.entries(payload)) {
      // check for image fields
      if (key === 'income_prove' || key === 'work_prove') {
        if (value) {
          formData.append(key, value.item(0));
        }
      } else if (typeof value === 'object') {
        formData.append(key, JSON.stringify(value));
      } else if (typeof value === 'undefined') {
        formData.append(key, '');
      } else {
        formData.append(key, value);
      }
    }
    return formData;
  };

  const onSubmitHandler = async (formValues: BorrowerProfileFormValues) => {
    setSubmitting(true);

    const payload: BorrowerDto = {
      location: {
        address: formValues.address!,
        city: formValues.city!,
        country_id: +formValues.country!,
        state_id: +formValues.state!,
      },
      is_self_employed: formValues.employment_type === EmploymentType.SELF_EMPLOYED,
      occupation: formValues.occupation,
      bvn: formValues.bvn,
      nin: formValues.nin,
      linkedin: formValues.linkedin,
      income_prove: formValues.income_prove,
      work_prove: formValues.work_prove,
    };

    if (formValues.employment_type === EmploymentType.SELF_EMPLOYED) {
      payload.business = {
        name: formValues.business_name!,
        location: {
          city: formValues.business_city!,
          state_id: +formValues.business_state!,
          country_id: +formValues.business_country!,
        },
        rc_no: formValues.rc_no!,
        business_type: formValues.business_type!,
        job_title: formValues.job_title!,
        duration: +formValues.business_duration!,
      };
    } else {
      payload.employer = {
        name: formValues.employer_name!,
        location: {
          city: formValues.employer_city!,
          state_id: +formValues.employer_state!,
          country_id: +formValues.employer_country!,
        },
        job_title: formValues.job_title!,
        duration: +formValues.employment_duration!,
      };
    }

    try {
      const formPayload: any = createMultiPartFormData(payload);
      const headers = { 'Content-type': 'multipart/form-data' };

      for (var pair of formPayload.entries()) {
        console.log(pair[0] + ', ' + pair[1]);
      }

      await updateBorrowerProfile(formPayload, headers);
      setSubmitting(false);
      toast.success('Your profile has been successfully updated');
    } catch (error) {
      setSubmitting(false);
      toast.error(handleApiError(error));
    }
  };

  return { onSubmitHandler, submitting };
};
